/** Mirrors satelliteengine `numberExceedsMaxDecimalPlaces` for client-side validation. */
export function numberExceedsMaxDecimalPlaces(
  num: number,
  maxPlaces: unknown
): boolean {
  if (maxPlaces === undefined || maxPlaces === null) {
    return false;
  }
  const max = Number(maxPlaces);
  if (!Number.isInteger(max) || max < 1 || max > 20) {
    return false;
  }
  if (!Number.isFinite(num)) {
    return true;
  }
  const factor = 10 ** max;
  const rounded = Math.round(num * factor) / factor;
  const tolerance = Math.max(Number.EPSILON * factor * 8, 1e-10);
  return Math.abs(num - rounded) > tolerance;
}
